module.exports = __webpack_public_path__ + "static/img_1081-ed42ac7f6aa729c472d8c924c4f880b2.webp";